import template from './leave-usage.html';
import controller from './leave-usage.controller';

let LeaveUsageModal = {
  animation: true,
  template,
  controller,
  controllerAs: '$ctrl',
  size: 'lg',
  windowClass: 'hmodal-info animated fadeIn leave-usage-modal'
};

export default LeaveUsageModal;




// WEBPACK FOOTER //
// ./client/pages/leave/modals/leave-usage/leave-usage.component.js